import { createReducer, on } from "@ngrx/store";
import { ADD_SEGMENT_MASTERS } from "../actions/segment-masters.action";
import { SegmentMastersModel } from "../models/segment-master.model";

const INITIAL_SEGMENT_MASTERS: SegmentMastersModel = {};

export const SegmentMastersReducer = createReducer(
  INITIAL_SEGMENT_MASTERS,
  on(ADD_SEGMENT_MASTERS, (_, segments) => segments),
);
